import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Input,
  Label,
  FormGroup,
} from "reactstrap";
import apiService from "services/api";
import { models, permission, permissionCheck } from "utils/permissionCheck";
import { colorMap, centres } from "../constants";
import { filterActions } from "../reducers";
import { CustomDropdownItem, TeacherFilterDropdown } from "./components";

const FilterDropdown = ({
  filterParams,
  dispatchFilterParams,
  teacherOptions,
}) => {
  const isAbleToViewAdminFilter = permissionCheck(
    apiService.auth.token.get(),
    models.ADMIN,
    [permission.SCHEDULE_READ],
  );

  return (
    <div className="d-flex justify-content-lg-end justify-content-between flex-wrap mb-3">
      <div className="d-flex mr-sm-2 mr-0">
        <FormGroup
          check
          className="rounded mt-0 mb-1 px-2 align-self-center py-1 mr-1"
        >
          <Label check>
            <Input
              type="checkbox"
              onChange={(event) =>
                dispatchFilterParams({
                  type: filterActions.BIRTHDAYS_DISPLAY,
                  payload: event.target.checked,
                })
              }
              checked={filterParams.birthdaysDisplay}
            />
            <span
              className="form-check-sign"
              style={{
                backgroundColor: "#1d8cf8",
                borderColor: "#1d8cf8",
              }}
            >
              <span className="check"></span>
            </span>
            <span className="font-weight-bold text-white">Birthdays</span>
          </Label>
        </FormGroup>
        {isAbleToViewAdminFilter && (
          <FormGroup
            check
            className="rounded mt-0 mb-1 px-2 align-self-center py-1 mr-1"
          >
            <Label check>
              <Input
                type="checkbox"
                onChange={(event) =>
                  dispatchFilterParams({
                    type: filterActions.STAFF_APPLICATION_DISPLAY,
                    payload: event.target.checked,
                  })
                }
                checked={filterParams.staffApplicationDisplay}
              />
              <span
                className="form-check-sign"
                style={{
                  backgroundColor: "#1d8cf8",
                  borderColor: "#1d8cf8",
                }}
              >
                <span className="check"></span>
              </span>
              <span className="font-weight-bold text-white">Leaves</span>
            </Label>
          </FormGroup>
        )}
        {isAbleToViewAdminFilter && (
          <FormGroup
            check
            className="rounded mt-0 mb-1 px-2 align-self-center py-1"
          >
            <Label check>
              <Input
                type="checkbox"
                onChange={(event) =>
                  dispatchFilterParams({
                    type: filterActions.LESSON_RECORD_DISPLAY,
                    payload: event.target.checked,
                  })
                }
                checked={filterParams.lessonRecordDisplay}
              />
              <span
                className="form-check-sign"
                style={{
                  backgroundColor: "#1d8cf8",
                  borderColor: "#1d8cf8",
                }}
              >
                <span className="check"></span>
              </span>
              <span className="font-weight-bold text-white">Lessons</span>
            </Label>
          </FormGroup>
        )}
      </div>
      <UncontrolledDropdown group className="mr-0 mr-sm-1">
        <DropdownToggle caret color="info" data-toggle="dropdown">
          Filter By Centre
        </DropdownToggle>
        <DropdownMenu style={{ paddingTop: 0, paddingBottom: 0 }}>
          <CustomDropdownItem
            onChange={(event) =>
              dispatchFilterParams({
                type: filterActions.SELECT_ALL_CENTRES,
                payload: event.target.checked,
              })
            }
            label="Select all"
            colorTag="transparent"
          />
          {centres.map((centre, index) => (
            <CustomDropdownItem
              key={index}
              colorTag={colorMap[centre]?.code}
              index={index}
              onChange={(event) =>
                dispatchFilterParams({
                  type: filterActions.CENTRE,
                  payload: {
                    centre,
                    show: event.target.checked,
                  },
                })
              }
              checked={filterParams?.centreFilter[centre]}
              label={centre}
            />
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>

      {isAbleToViewAdminFilter && (
        <TeacherFilterDropdown
          filterParams={filterParams}
          dispatchFilterParams={dispatchFilterParams}
          teacherOptions={teacherOptions}
        />
      )}
    </div>
  );
};

export { FilterDropdown };
